module.exports = __webpack_public_path__ + "static/media/kiss-wink-heart.92a9737c.svg";